module.exports = __webpack_public_path__ + "img/b-.86e5adc8.png";